import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./utils/AuthContext";
import AppRoutes from "./Routes";
import GlobalBanner from "./components/GlobalBanner";
import GlobalFooter from "./components/GlobalFooter";
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <GlobalBanner />
        <AppRoutes />
        <GlobalFooter />
      </Router>
    </AuthProvider>
  );
};

export default App;